import React from 'react';

const DeploymentOrganization = () => {
  return <h3>TODO: implement later</h3>;
};

export default DeploymentOrganization;
